// extracted by mini-css-extract-plugin
module.exports = {"noReports":"NoReports_noReports__131zj","content":"NoReports_content__30slW","icon":"NoReports_icon__1f-6a","title":"NoReports_title__160I2","subTitle":"NoReports_subTitle__2-Tg8"};